import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Tab, Tabs, TextField, Box, Typography, Grid, IconButton, DialogActions } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import moment from "moment";
import TableComponent from "components/grid";
import CustomPagination from "components/CustomPagination";
import { RxCross2 } from "react-icons/rx";
import { useGetServiceDetailsQuery } from "store/slices/apis/procurementDashboardSlice";
import { useGetBoughtOutItemDetailsQuery, useLazyGetBoughtOutItemDetailsQuery } from "store/slices/apis/procurementDashboardSlice";


const ProcurementListPopUp = (props) => {
    const { header, open, handleClose, data, } = props;
    const { projectId } = useParams();
    const [loading, setLoading] = useState(false);
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const dispatch = useDispatch();
    const [subTabValue, setSubTabValue] = useState(0)

    const subTabs = [
        { label: "Bought Item", value: 0 },
        { label: "DP Item", value: 1 },

    ];

    const [filters, setFilters] = useState({
        ...data,
        ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,

    });

    useEffect(() => {
        trigger(filters);
    }, []);


    const [trigger, { data: procurementList, isLoading }] = useLazyGetBoughtOutItemDetailsQuery()

    const getData = (value) => {
        if (value === 0) {
            return procurementList?.data?.boItems || [];
        }
        if (value === 1) {
            return procurementList?.data?.dpItems || [];
        }
        return [];
    };

    const getCount = (value) => {
        if (value === 0) {
            return procurementList?.data?.boItemCount || 0;
        }
        if (value === 1) {
            return procurementList?.data?.dpItemCount || 0;
        }
        return 0;

    }
    const handleRequestSort = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';

        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'
        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handleSubTabChange = (event, newValue) => {
        setSubTabValue(newValue);
    };

    const getColumns = () => {
        if (subTabValue === 0) {
            return [
                // {
                //     name: "",
                //     field: "actions",
                //     width: "10px",
                //     sticky: true,
                //     renderer: (row) => (
                //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                //             <IconButton
                //                 size="small"
                //                 onClick={(e) => handleMenuOpen(e, row)}
                //             >
                //                 <MoreVertIcon fontSize="small" />
                //             </IconButton>
                //         </Box>
                //     ),
                // },
                {
                    name: "ID",
                    field: "customId",
                    width: "100px",
                    sticky: true
                },
                {
                    name: "Sub Project",
                    field: "subProject",
                    sticky: true,

                },
                {
                    name: "Vendor Name",
                    field: "vendorName",
                    sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.vendorName ? row?.vendorName : '-'}
                        </>
                    ),
                },
                {
                    name: "Material Procurement Status",
                    field: "materialProcurementStatus",
                    // sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.materialProcurementStatus ? row?.materialProcurementStatus : '-'}
                        </>
                    ),
                },

                {
                    name: "Material Category",
                    field: "materialCategory",
                    renderer: (row) => (
                        <>
                            {row?.materialCategory ? row?.materialCategory : '-'}
                        </>
                    ),
                },
                {
                    name: "UOM",
                    field: "uom",
                    renderer: (row) => (
                        <>
                            {row?.uom ? row?.uom : '-'}
                        </>
                    ),
                },
                {
                    name: "Quantity Required",
                    field: "quantityRequired",
                    renderer: (row) => (
                        <>
                            {row?.quantityRequired ? row?.quantityRequired : '-'}
                        </>
                    ),
                },
                {
                    name: "Lead Time",
                    field: "leadTime",
                    renderer: (row) => (
                        <>
                            {row?.leadTime ? row?.leadTime : '-'}
                        </>
                    ),
                },
                {
                    name: "Procurement Method",
                    field: "procurementMethod",
                    renderer: (row) => (
                        <>
                            {row?.procurementMethod ? row?.procurementMethod : '-'}
                        </>
                    ),
                },
                {
                    name: "Source Department",
                    field: "sourceDepartment",
                    renderer: (row) => (
                        <>
                            {row?.sourceDepartment ? row?.sourceDepartment : '-'}
                        </>
                    ),
                },
                {
                    name: "Procurement Owner",
                    field: "procurementOwner",
                    renderer: (row) => (
                        <>
                            {row?.procurementOwner ? row?.procurementOwner : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Cost",
                    field: "actualCost",
                    renderer: (row) => (

                        <>
                            {row?.actualCost !== null && row?.actualCost !== undefined
                                ? Number(row.actualCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>

                    ),
                },
                {
                    name: "Budgeted Cost",
                    field: "budgetedCost",
                    renderer: (row) => (
                        <>
                            {row?.budgetedCost !== null && row?.budgetedCost !== undefined
                                ? Number(row.budgetedCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                {
                    name: "Budgeted Unit Rate",
                    field: "budgetedUnitRate",
                    renderer: (row) => (
                        <>
                            {row?.budgetedUnitRate ? row?.budgetedUnitRate : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Unit Rate",
                    field: "actualUnitRate",
                    renderer: (row) => (
                        <>
                            {row?.actualUnitRate ? row?.actualUnitRate : '-'}
                        </>
                    ),
                },
                {
                    name: "Material Description",
                    field: "materialDescription",
                    width: "300px",

                },
                {
                    name: "Requisition Date",
                    field: "requisitionDate",
                    renderer: (row) => (
                        <>
                            {row?.requisitionDate ? moment(row.requisitionDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Date Of Release Of LOI/WO/PO",
                    field: "plannedLoiWoPoReleaseDate",
                    renderer: (row) => (
                        <>
                            {row?.plannedLoiWoPoReleaseDate ? moment(row.plannedLoiWoPoReleaseDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Date",
                    field: "poDate",
                    renderer: (row) => (
                        <>
                            {row?.poDate ? moment(row.poDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Number",
                    field: "poNumber",
                    renderer: (row) => (
                        <>
                            {row?.poNumber ? row?.poNumber : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Quanity",
                    field: "poQuantity",
                    renderer: (row) => (
                        <>
                            {row?.poQuantity ? Number(row.poQuantity).toFixed(2) : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Rate",
                    field: "poRate",
                    renderer: (row) => (
                        <>
                            {row?.poRate ? Number(row.poRate).toFixed(2) : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Value (Cr)",
                    field: "poValue",
                    renderer: (row) => (
                        <>
                            {row?.poValue ? row?.poValue : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Delivery Date",
                    field: "plannedDeliveryDate",
                    renderer: (row) => (
                        <>
                            {row?.plannedDeliveryDate ? moment(row.plannedDeliveryDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Delivery Date",
                    field: "actualDeliveryDate",
                    renderer: (row) => (
                        <>
                            {row?.actualDeliveryDate ? moment(row.actualDeliveryDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Delivered Qty",
                    field: "deliveredQty",
                    renderer: (row) => (
                        <>
                            {row?.deliveredQty ? row?.deliveredQty : '-'}
                        </>
                    ),
                },
                {
                    name: "Pending Qty",
                    field: "pendingQty",
                    renderer: (row) => (
                        <>
                            {row?.pendingQty ? row?.pendingQty : '-'}
                        </>
                    ),
                },
                {
                    name: "Delivery Variance",
                    field: "deliveryVariance",
                    renderer: (row) => (
                        <>
                            {row?.deliveryVariance ? row?.deliveryVariance : '-'}
                        </>
                    ),
                },
                {
                    name: "Remarks / Notes",
                    field: "remarks",
                    width: "300px",
                    renderer: (row) => (
                        <>
                            {row?.remark ? row?.remark : '-'}
                        </>
                    ),
                },
            ];
        } else {
            return [
                // {
                //     name: "",
                //     field: "actions",
                //     width: "10px",
                //     sticky: true,
                //     renderer: (row) => (
                //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                //             <IconButton
                //                 size="small"
                //                 onClick={(e) => handleMenuOpen(e, row)}
                //             >
                //                 <MoreVertIcon fontSize="small" />
                //             </IconButton>
                //         </Box>
                //     ),
                // },
                {
                    name: "ID",
                    field: "customId",
                    width: "100px",
                    sticky: true,
                    renderer: (row) => (
                        <>
                            {row?.customId ? row?.customId : '-'}
                        </>
                    ),
                },

                {
                    name: "Sub Project",
                    field: "subProject",
                    width: "120px",
                    // renderer: (row) => highlightText(row.subProject, searchTerm),
                },

                {
                    name: "Material Description",
                    field: "materialDescription",
                    width: "300px",
                    sticky: true,

                },
                {
                    name: "Material Category",
                    field: "materialCategory",
                    width: "150px",
                    renderer: (row) => (
                        <>
                            {row?.materialCategory ? row?.materialCategory : '-'}
                        </>
                    ),
                },
                {
                    name: "UOM",
                    field: "uom",
                    width: "80px",
                    renderer: (row) => (
                        <>
                            {row?.uom ? row?.uom : '-'}
                        </>
                    ),
                },
                {
                    name: "Quantity Required",
                    field: "quantityRequired",
                    width: "120px",
                    renderer: (row) => (
                        <>
                            {row?.quantityRequired ? row?.quantityRequired : '-'}
                        </>
                    ),
                },
                {
                    name: "Process Time (Indent to LOI)",
                    field: "processTime",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.processTime ? row?.processTime : '-'}
                        </>
                    ),
                },
                {
                    name: "Lead Time (Days)",
                    field: "leadTimeDays",
                    width: "120px",
                    renderer: (row) => (
                        <>
                            {row?.leadTimeDays ? row?.leadTimeDays : '-'}
                        </>
                    ),
                },
                {
                    name: "Procurement Method",
                    field: "procurementMethod",
                    renderer: (row) => (
                        <>
                            {row?.procurementMethod ? row?.procurementMethod : '-'}
                        </>
                    ),
                },
                {
                    name: "Source Department",
                    field: "sourceDepartment",
                    renderer: (row) => (
                        <>
                            {row?.sourceDepartment ? row?.sourceDepartment : '-'}
                        </>
                    ),
                },
                {
                    name: "Procurement Owner",
                    field: "procurementOwner",
                    renderer: (row) => (
                        <>
                            {row?.procurementOwner ? row?.procurementOwner : '-'}
                        </>
                    ),
                },
                {
                    name: "Requisition Date",
                    field: "requisitionDate",
                    width: "130px",
                    renderer: (row) => (
                        <>
                            {row?.requisitionDate ? moment(row.requisitionDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Date Of Tender Package",
                    field: "plannedDateOfTenderPackage",
                    renderer: (row) => (
                        <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {row?.plannedDateOfTenderPackage ? moment(row.plannedDateOfTenderPackage).format("DD MMM YYYY") : '-'}
                        </Box>
                    ),
                },
                {
                    name: "Planned LOI/WO/PO Release Date",
                    field: "plannedLoiWoPoReleaseDate",
                    width: "200px",
                    renderer: (row) => (
                        <>
                            {row?.plannedLoiWoPoReleaseDate ? moment(row.plannedLoiWoPoReleaseDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Vendor Name",
                    field: "vendorName",
                    width: "150px",
                    renderer: (row) => (
                        <>
                            {row?.vendorName ? row?.vendorName : '-'}
                        </>
                    ),
                },
                {
                    name: "PO/Loi Date",
                    field: "poDate",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.poDate ? moment(row.poDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Number",
                    field: "poNumber",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.poNumber ? row?.poNumber : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Quantity",
                    field: "poQuantity",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.poQuantity ? Number(row.poQuantity).toFixed(2) : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Rate",
                    field: "poRate",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.poRate ? Number(row.poRate).toFixed(2) : '-'}
                        </>
                    ),
                },
                {
                    name: "PO Value",
                    field: "poValue",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.poValue ? row?.poValue : '-'}
                        </>
                    ),
                },
                {
                    name: "Planned Delivery Date",
                    field: "plannedDeliveryDate",
                    width: "150px",
                    renderer: (row) => (
                        <>
                            {row?.plannedDeliveryDate ? moment(row.plannedDeliveryDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Delivery Date",
                    field: "actualDeliveryDate",
                    width: "150px",
                    renderer: (row) => (
                        <>
                            {row?.actualDeliveryDate ? moment(row.actualDeliveryDate).format("DD MMM YYYY") : '-'}
                        </>
                    ),
                },
                {
                    name: "Delivered Qty",
                    field: "deliveredQty",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.deliveredQty ? row?.deliveredQty : '-'}
                        </>
                    ),
                },
                {
                    name: "Pending Qty",
                    field: "pendingQty",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.pendingQty ? row?.pendingQty : '-'}
                        </>
                    ),
                },
                {
                    name: "Delivery Variance",
                    field: "deliveryVariance",
                    width: "120px",
                    renderer: (row) => (
                        <>
                            {row?.deliveryVariance ? row?.deliveryVariance : '-'}
                        </>
                    ),
                },
                {
                    name: "Material Procurement Status",
                    field: "materialProcurementStatus",
                    width: "180px",
                    renderer: (row) => (
                        <>
                            {row?.materialProcurementStatus ? row?.materialProcurementStatus : '-'}
                        </>
                    ),
                },
                {
                    name: " Status",
                    field: "status",
                    renderer: (row) => (
                        <>
                            {row?.status ? row?.status : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Cost (In Crores)",
                    field: "actualCost",
                    width: "100px",
                    renderer: (row) => (
                        <>
                            {row?.actualCost !== null && row?.actualCost !== undefined
                                ? Number(row.actualCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                {
                    name: "Budgeted Cost (In Crores)",
                    field: "budgetedCost",
                    width: "120px",
                    renderer: (row) => (
                        <>
                            {row?.budgetedCost !== null && row?.budgetedCost !== undefined
                                ? Number(row.budgetedCost).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })
                                : '-'}
                        </>
                    ),
                },
                {
                    name: "Budgeted Unit Rate (In Crores)",
                    field: "budgetedUnitRate",
                    width: "150px",
                    renderer: (row) => (
                        <>
                            {row?.budgetedUnitRate ? row?.budgetedUnitRate : '-'}
                        </>
                    ),
                },
                {
                    name: "Actual Unit Rate (In Crores)",
                    field: "actualUnitRate",
                    width: "150px",
                    renderer: (row) => (
                        <>
                            {row?.actualUnitRate ? row?.actualUnitRate : '-'}
                        </>
                    ),
                },
                {
                    name: "Note",
                    field: "note",
                    width: "200px",
                    renderer: (row) => (
                        <>
                            {row?.note ? row?.note : '-'}
                        </>
                    ),
                },
            ];
        }
    };

    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isSuccess) {
    //         if (!addActionTrackerRes?.data?.status) {
    //             openNotification(addActionTrackerRes?.data?.message, 'success')
    //             handleClose();
    //         } else {
    //             openNotification(addActionTrackerRes?.data?.message, 'error')
    //         }
    //     }
    // }, [addActionTrackerRes?.isSuccess]);


    // React.useEffect(() => {
    //     if (addActionTrackerRes?.isError) {
    //         if (addActionTrackerRes?.error?.data?.status == 'fail') {
    //             openNotification(addActionTrackerRes?.error?.data?.message, 'error')
    //         } else {
    //             openNotification('Something went wrong!', 'error')
    //         }
    //         // cancel();
    //     }
    // }, [addActionTrackerRes?.isError]);

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >

            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                    {header}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>
            <DialogActions>
                <Box
                    sx={{
                        width: "100%",
                        //borderBottom: "2px solid #ECECEC",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        mt: 1,
                        ml: 2,
                    }}
                >
                    <Tabs
                        value={subTabValue}
                        onChange={handleSubTabChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        variant="scrollable"
                        scrollButtons={false}
                        sx={{
                            "& .MuiTabs-flexContainer": {
                                gap: "30px",
                            },
                        }}
                    >
                        {subTabs.map((item, index) => (
                            <Tab
                                key={index}
                                label={
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            color: subTabValue === index ? "#0E73F6" : "#7E7E7E",
                                            fontFamily: "Outfit, sans-serif",
                                        }}
                                    >
                                        {item.label}
                                    </Typography>
                                }
                                sx={{
                                    textTransform: "none",
                                    minWidth: "auto",
                                    paddingBottom: "5px",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    borderBottom:
                                        subTabValue === index
                                            ? "2px solid #0E73F6"
                                            : "2px solid transparent",
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>
            </DialogActions>
            <DialogContent dividers>
                <Grid container>
                    <Grid size={{ md: 12 }}>
                        <TableComponent
                            columns={getColumns(subTabValue)}
                            data={getData(subTabValue)}
                            createSortHandler={handleRequestSort}
                            loading={isLoading}
                            order={sortOrder}
                            orderBy={sortBy}
                        />
                    </Grid>
                    <Grid size={{ md: 12 }}>
                        <CustomPagination
                            totalCount={getCount(subTabValue)}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ProcurementListPopUp;
